module.exports = "/_next/static/images/CustomDestinations-be85edd458a0eac67ab6b21008bec3c3.webp";